import React, { FC } from 'react';

import { GradientDot } from '@trqk/components';

interface IconProps {
    width: number;
    fillColor: string;
}

interface Props {
    bgClass: string;
    Icon: FC<IconProps>;
    label: string;
    value: string;
}

export const KPI = ({ bgClass, Icon, label, value }: Props): JSX.Element => (
        <div
            className={`${bgClass} rounded-lg px-8 py-6 text-white flex justify-start items-center`}
        >
            <GradientDot width={50} gradientColor="tertiary">
                <Icon width={30} fillColor="tertiary-100" />
            </GradientDot>
            <div className="flex flex-col ml-6">
                <div className="text-xl font-bold text-white">{value}</div>
                <div className="text-sm">{label}</div>
            </div>
        </div>
    );
